<template>
  <div :class="['container',  _isMobile()?'mobile':'']">
    <a-card class="search-card" :bordered="false">
      <j-dict-select-tag
        :defaultShowAll="true"
        type="radioButton"
        @change="handleChangeType"
        v-model="courseType"
        :trigger-change="true"
        dictCode="course_type"
      />
    </a-card>
    <a-divider />
    <a-card :bordered="false">
      <a-skeleton v-if="loading"/>
      <a-list
        :grid="{ gutter: _isMobile()?12:24, lg: 4, md: 3, sm: 2, xs: 2 }"
        :dataSource="dataSource"
        :pagination="pagination"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card :bordered="false" @click="toDetail(item.id)">
            <img class="cover" :src="item.courseCover_url" alt="">
            <h3 class="title">{{ item.courseName }}</h3>
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG,ACCESS_TOKEN } from "@/store/mutation-types";
import {getAction} from "@/api/manage"
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
  },
  data() {
    return {
      dataSource: [
      ],
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: this._isMobile()?8:12,
      },
      loading: true,
      courseType: "",
      token: '',
      tenantConfig:{}
    };
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (Vue.ls.get(ACCESS_TOKEN)){
      this.token = Vue.ls.get(ACCESS_TOKEN)
    }
    this.getCourseList()
  },
   mounted(){
    window.document.title = this.tenantConfig.brandName + " " +"课程教学"
  },
  methods: {
    handleChangeType(v) {
      this.courseType = v.target.value
      this.getCourseList()
    },
    getCourseList(){
      this.loading = true
      this.dataSource = []
      // if(this.token){
      //   getAction('/teaching/teachingCourse/studentCourseNew', {}).then(res => {
      //     if (res.success) {
      //       this.dataSource = res.result
      //     }
      //     if (res.code === 510) {
      //       this.$message.warning(res.message)
      //     }
      //     this.loading = false
      //   })
      // }else{
        getAction("/teaching/teachingCourse/showCourse", {
          courseType: this.courseType,
           pageSize:999, 
          //  isShow:1
           }).then(res=>{
          console.log(res);
          if(res.success){
            this.dataSource = res.result.records
          }
          this.loading = false
        })
      // }
    },
    toDetail(id){
      this.$router.push({
        path: '/course/detail',
        query: {
          id: id,
        },
      })
    }
  },
};
</script>

<style lang="less" scoped>
.cover{
  width: 100%;
  height: 170px;
}
.title{
  margin-top: 5px;
}
.title:hover{
  color: #1890FF;
}
.search-card{
  /deep/.ant-card-body{
    padding: 20px;
  }
}
/deep/.ant-list-item{
  cursor: pointer;
  .ant-card-body{
    padding: 0;
  }
}

.mobile{
  .cover{
    height: 100px!important;
  }
}
</style>